import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=221a1921&scoped=true&"
import script from "./HeaderTitle.vue?vue&type=script&lang=js&"
export * from "./HeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTitle.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HeaderTitle.vue?vue&type=style&index=1&id=221a1921&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a1921",
  null
  
)

export default component.exports